import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconBookmarkSvg } from "./IconBookmarkSvg.mjs";
import { IconBookmarkActiveSvg } from "./IconBookmarkActiveSvg.mjs";
const IconBookmark = ({
  active = false,
  ...props
}) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: active ? IconBookmarkActiveSvg : IconBookmarkSvg,
      ...iconProps
    }
  );
};
export {
  IconBookmark
};
